<template>
    <div class="login-screen">
        <Header/>
        <PageHeader title="在宅看護指導士認定登録"/>
        <article class="login-page">
            <div class="login-page-container">
                <div class="description">
                    郵送されてきたＩＤ・パスワードを入力してください
                </div>
                <form @submit.prevent="onSubmit">
                    <input class="id-input" placeholder="ID" v-model="auth.auth_name" title="ID">
                    <ErrorText :errors="errors" name="auth_name"/>
                    <input type="password" class="password-input" placeholder="パスワード" title="パスワード"
                           v-model="auth.password">
                    <ErrorText :errors="errors" name="password"/>
                    <Agreement/>
                    <label class="agreement-label">
                        <input type="checkbox" v-model="auth.agreement"/>
                        利用規約・プライバシーポリシーに同意します
                    </label>
                    <button type="submit" class="submit-button" :disabled="!submitEnabled">認定登録へ進む</button>
                </form>
            </div>
        </article>
    </div>
</template>

<script>
import Header from "../../parts/app/Header";
import PageHeader from "../../parts/app/PageHeader";
import ErrorText from "../../parts/ErrorText";
import Agreement from "../../parts/app/Agreement";

export default {
    name: "Login",
    components: {Agreement, ErrorText, PageHeader, Header},

    data() {
        return {
            auth: {
                auth_name: '',
                password: '',
                agreement: false,
            },
            errors: {}
        }
    },

    computed: {
        submitEnabled() {
            return this.auth.auth_name && this.auth.password && this.auth.agreement;
        }
    },

    methods: {
        async onSubmit() {
            try {
                this.errors = {};
                await this.$http.post('auth/login', this.auth);
                await this.$router.push('/application');
            } catch (e) {
                this.errors = e.response?.data?.errors ?? {};
                this.$toastr.error('登録できませんでした。');
            }
        }
    }
}
</script>

<style scoped>

</style>
